import { render, staticRenderFns } from "./PreCustomerDashboard.vue?vue&type=template&id=4a8aa072"
import script from "./PreCustomerDashboard.vue?vue&type=script&lang=ts"
export * from "./PreCustomerDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports